import React, { FC, useRef } from 'react'
import { motion, useInView } from 'framer-motion'

type QuivverDetailsProps = {
    quivverProject: any
}

const QuivverDetails: FC<QuivverDetailsProps> = ({ quivverProject }) => {
    const containerRef = useRef(null);
    const titleRef = useRef(null);
    const isInView = useInView(containerRef, { once: false, amount: 0.2 });
    const isTitleInView = useInView(titleRef, { once: false, amount: 0.3 });

    const itemVariants = {
        hidden: (i: number) => {
            // Alternate between left, right, and top animations
            const direction = i % 3;
            if (direction === 0) {
                return { opacity: 0, x: -80, y: 0 };
            } else if (direction === 1) {
                return { opacity: 0, x: 80, y: 0 };
            } else {
                return { opacity: 0, x: 0, y: -50 };
            }
        },
        visible: (i: number) => ({
            opacity: 1,
            x: 0,
            y: 0,
            transition: {
                duration: 0.7,
                delay: i * 0.15,
                ease: [0.25, 0.1, 0.25, 1.0]
            }
        })
    };

    return (
        <div className='pt-10 px-4 sm:px-6 md:px-12 lg:px-20 xl:px-40 pb-12 sm:pb-16 md:pb-20'>
            <motion.div
                ref={titleRef}
                initial={{ opacity: 0, y: -50 }}
                animate={isTitleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -50 }}
                transition={{ duration: 0.8 }}
            >
                <h2 className="text-center uppercase font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl text-[#2DEE9A] mb-8 sm:mb-12 md:mb-16 lg:mb-20">
                    Details
                </h2>
            </motion.div>
            <div className='flex flex-col gap-6 sm:gap-8' ref={containerRef}>
                {quivverProject.quivverProjectDeatils.quivverDetails.map((details: any, index: number) => {
                    return (
                        <motion.div
                            key={details.key || index}
                            className='flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 md:gap-8'
                            variants={itemVariants}
                            initial="hidden"
                            animate={isInView ? "visible" : "hidden"}
                            custom={index}
                        >
                            <motion.div
                                className={`w-16 h-16 sm:w-20 sm:h-20 rounded-full ${details.bgColor} flex items-center justify-center font-bold text-xl sm:text-2xl md:text-3xl relative z-10 text-black flex-shrink-0`}
                                whileHover={{ scale: 1.1, rotate: 360 }}
                                transition={{ duration: 0.5 }}
                            >
                                {details.key}.
                                <div className="absolute inset-0 rounded-full bg-white opacity-20" />
                            </motion.div>
                            <div className='flex flex-col gap-1 sm:gap-2'>
                                <div className='text-xl sm:text-2xl md:text-3xl font-bold text-white'>
                                    {details.title}
                                </div>
                                <div className='text-base sm:text-lg md:text-xl text-[#CDCDCD]'>
                                    {details.sub_title}
                                </div>
                            </div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default QuivverDetails